import axios from 'axios';
import { URL } from '../redux/api';

// This client never carries account credentials or refreshes a guest token.
const client = axios.create({ baseURL: URL });

export const resolveCompanion = (sessionId, signal, qrSource = 'autre') =>
  client.post(
    '/api/companion/resolve',
    {},
    {
      signal,
      headers: {
        'X-Companion-Entry-Method': 'direct',
        'X-Companion-Session-Id': sessionId,
        'X-Companion-QR-Source': qrSource,
      },
    }
  );

export function companionExpiresAt(token) {
  try {
    const encoded = token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')));
    return Number.isFinite(exp) ? exp * 1000 : 0;
  } catch {
    return 0;
  }
}
